// extracted by mini-css-extract-plugin
export default {"user":"user_user__8O72p","title":"user_title__To9vs","fields":"user_fields__bDqd7","field":"user_field__X-hM5","buttons":"user_buttons__FFhTL"};